/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, throwError } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import firebase from 'firebase/compat/app';
// import { ref } from '@touchplan/common';

@Injectable({ providedIn: 'root' })
export class ShallowRequest {
	constructor(private http: HttpClient, private afAuth: AngularFireAuth) {}

	/**
	 * Accepts a standard "root scoped" firebase path `tickets/-asdfasdf` etc. And returns an observable which emits a list of children
	 * id's at that path once.
	 */
	public request(ref: firebase.database.Reference): Observable<string[] | null> {
		return this.getAuthToken().pipe(
			switchMap((authToken) => {
				if (!authToken) {
					return throwError(new Error('auth is undefined'));
				}
				return this.makeRequest(this.decorateFbPath(ref, authToken));
			}),
			map((objList) => (objList ? Object.keys(objList) : null)), //http returns null when nothing is there
			take(1)
		);
	}

	private makeRequest(fullPath: string) {
		return this.http.get(fullPath);
	}

	private getAuthToken() {
		return this.afAuth.idToken;
	}

	private decorateFbPath(fbRef: firebase.database.Reference, authToken: string) {
		// const fbRef = this.safeRef(pathFromRoot);
		const fullPath = fbRef.toString();
		return `${fullPath}.json?shallow=true&auth=${authToken}`;
	}
}
